module.exports = __webpack_public_path__ + "img/anxiety-icon-1.18f20304.svg";